import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { Credit } from '../models/credit.model';

@Injectable({ providedIn: 'root' })
export class CreditService extends AbstractService<Credit> {

  getURLBase(): string {
    return '/credit';
  }

  constructor(http: HttpClient) {
    super(http);
  }

  preCreate(obj: Credit): void {
    delete obj?._id;
  }

  preUpdate(obj: Credit): void { }

  listByCompany(idCompany: string): Observable<Credit[]> {
    return super.getWithParams('/list', { company: idCompany });
  }
}
